export enum EntitySubCustomersType {
  SECONDARY_CUSTOMER = "SecondaryCustomer",
  GUARANTOR = "Guarantor",
}

export const EntitySubCustomersTypeTranslationMapper = new Map<EntitySubCustomersType, string>([
  [EntitySubCustomersType.SECONDARY_CUSTOMER, "SUB_CUSTOMERS.TYPES.SECONDARY"],
  [EntitySubCustomersType.GUARANTOR, "SUB_CUSTOMERS.TYPES.GUARANTOR"],
]);
